import { apiClient } from '../../../../../../../../api';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { getAuditListingDefaultDateRange } from '@app/modules/audit/modules/station-audit/helpers/default-listing-date-range';
import { ListingView } from '../../../../../../../../core/reports/components/ListingView';
import { MentionsMatchesForm } from './MentionsMatchesForm';
import { MentionsMatchesList } from './MentionsMatchesList';
import { MentionsMatchesListing } from './types';
import { Station } from '@app/core/types/stations';

type Props = {
  station: Station;
};

export function MentionsMatchesView(p: Props) {
  const tz = useTimezone();

  return (
    <ListingView<MentionsMatchesListing>
      defaultValues={{
        ...getAuditListingDefaultDateRange(tz),
        name: '',
      }}
      queryParamsTransform={{
        name: {
          parse: (input) => input,
          serialize: (input) => input.replace(/\s/g, ''),
        },
      }}
      reportFn={async (values) => {
        return apiClient.audit.fetchLiveMentionsMatches({
          stationId: p.station.id,
          filter: {
            from: values.from,
            to: values.to,
            name: values.name
              ?.split(',')
              .filter((value) => !!value)
              .map((value) => value.trim())
              .join(','),
          },
          pageSize: values.pageSize,
          page: values.pageIndex,
          sort: values.sort,
        });
      }}
      Form={MentionsMatchesForm}
      Result={MentionsMatchesList}
    />
  );
}
